export { default as GDMDocumentMask } from './GDMDocumentMask';

export type { GDMDocumentMaskComponent } from './GDMDocumentMask.type';
